import { change } from 'redux-form';
import query from './getTripDetailsQuery.graphql';
import { getDistanceAndDuration, getMapDirections } from '../../../helpers/ManualBooking/googleMapAPI';
import showToaster from '../../../helpers/showToaster';

export default function getTripDetails({ variables, isReload, locations }) {
  return async (dispatch, getState, { client }) => {
    let bookingLocations = [], loaderName = isReload ? 'reloadButton' : 'stepTwo';
    try {

      dispatch(change("ManualBookingForm", ("loaders." + loaderName), true));

      if (!isReload) {
        const estimation = await getDistanceAndDuration({ distanceType: variables?.distanceType, locations });
        variables.totalDistance = estimation?.totalDistance;
        variables.totalDuration = estimation?.totalDuration;
        bookingLocations = estimation?.bookingLocations;
      }

      if (!variables.totalDistance || !variables.totalDuration) {
        dispatch(change("ManualBookingForm", ("loaders." + loaderName), false));
        showToaster({ messageId: 'getTripDetails', toasterType: 'error' })
        return false;
      }

      const { data } = await client.query({
        query,
        variables,
        fetchPolicy: 'network-only'
      });

      if (data?.getTripDetails?.status === 200) {
        if (!isReload) {
          let requestData = {}, intermediates = [];
          if (bookingLocations?.length > 0) {
            requestData = {
              origin: {
                location:
                {
                  latLng: {
                    latitude: bookingLocations[0]?.locationLat,
                    longitude: bookingLocations[0]?.locationLng
                  }
                }
              },
              destination: {
                location: {
                  latLng: {
                    latitude: bookingLocations[bookingLocations.length - 1].locationLat,
                    longitude: bookingLocations[bookingLocations.length - 1].locationLng
                  }
                }
              }
            };

            if (bookingLocations.length > 2) {
              bookingLocations.map((location, index) => {
                if (index !== 0 && index !== bookingLocations.length - 1) {
                  intermediates.push({
                    location: {
                      latLng:
                      {
                        latitude: location?.locationLat, longitude: location?.locationLng
                      }
                    }
                  })
                }
              });
            }

            requestData['intermediates'] = intermediates;
            requestData['distanceType'] = variables?.distanceType;

            let mapRouteDirections = [], mapMarkerPoints = [], directionData = [];
            const { data } = await getMapDirections(requestData);

            if (data?.routes?.length > 0 && data?.routes[0]?.legs?.length > 0) {
              directionData = data?.routes[0]?.legs;
            }

            if (directionData?.length > 1) {
              for (const direction of directionData) {
                direction?.steps?.map((item) => {
                  if (item?.polyline?.encodedPolyline) {
                    const decodedPolyline = google.maps.geometry.encoding.decodePath(item?.polyline?.encodedPolyline);
                    mapRouteDirections = [...mapRouteDirections, ...decodedPolyline];
                  }
                });
              }
            } else if (directionData?.length > 0) {
              directionData[0]?.steps?.map((item) => {
                if (item?.polyline?.encodedPolyline) {
                  const decodedPolyline = google.maps.geometry.encoding.decodePath(item?.polyline?.encodedPolyline);
                  mapRouteDirections = [...mapRouteDirections, ...decodedPolyline];
                }
              });
            }

            if (mapRouteDirections?.length > 0 && requestData) {
              //mapMarkerPoints should be always start with origin and end with destination. In between stops should be added. 
              // Based on this variable index, the orgin, destination and stop points are differentiated in the map.
              if (requestData?.origin?.location?.latLng) {
                mapMarkerPoints.push({ lat: requestData?.origin?.location?.latLng?.latitude, lng: requestData?.origin?.location?.latLng?.longitude })
              }

              if (requestData?.intermediates?.length > 0) {
                requestData?.intermediates?.map((item) => {
                  if (item?.location?.latLng) {
                    mapMarkerPoints.push({ lat: item?.location?.latLng?.latitude, lng: item?.location?.latLng?.longitude })
                  }
                })
              }

              if (requestData?.destination?.location?.latLng) {
                mapMarkerPoints.push({ lat: requestData?.destination?.location?.latLng?.latitude, lng: requestData?.destination?.location?.latLng?.longitude })
              }
            }

            if (directionData?.viewport) {
              await dispatch(change("ManualBookingForm", 'sw_lat', directionData?.viewport?.low?.latitude));
              await dispatch(change("ManualBookingForm", 'sw_lng', directionData?.viewport?.low?.longitude));
              await dispatch(change("ManualBookingForm", 'ne_lat', directionData?.viewport?.high?.latitude));
              await dispatch(change("ManualBookingForm", 'ne_lng', directionData?.viewport?.high?.longitude));
            }

            if (mapMarkerPoints?.length === bookingLocations?.length) {
              await dispatch(change("ManualBookingForm", 'mapRouteDirections', mapRouteDirections));
              await dispatch(change("ManualBookingForm", 'mapMarkerPoints', mapMarkerPoints));
            }
          }
          await dispatch(change("ManualBookingForm", 'totalDistance', variables.totalDistance));
          await dispatch(change("ManualBookingForm", 'totalDuration', variables.totalDuration));
          await dispatch(change("ManualBookingForm", 'bookingLocations', bookingLocations));
          await dispatch(change("ManualBookingForm", 'stepTwoCompleted', true));
        }
        await dispatch(change("ManualBookingForm", 'categories', data.getTripDetails.results));
        await dispatch(change("ManualBookingForm", ("loaders." + loaderName), false));
      }
      else {
        showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: data.getTripDetails.errorMessage })
        dispatch(change("ManualBookingForm", ("loaders." + loaderName), false));
      }
      return true;
    } catch (error) {
      dispatch(change("ManualBookingForm", ("loaders." + loaderName), false));
      showToaster({ messageId: 'catchError', toasterType: 'error', requestContent: error })
      return false;
    }
  };
}